import React from 'react';
import FlowReductionWizard from './FlowReductionWizard.js';
import { AERATOR_CATALOG } from './aeratorCatalog.js';

const FAUCET_TYPE_LABELS = {
  technical: 'Technique',
  hand_wash: 'Lave-mains',
  changing_room: 'Vestiaire / Salle de bain',
  other: 'Autre',
};

const FAUCET_TYPE_ORDER = ['hand_wash', 'changing_room', 'technical', 'other'];

const AeratorSubModule = ({ equipments, usages, waterPricing, onResultChange }) => (
  <FlowReductionWizard
    equipmentType="faucet"
    equipmentTypeLabel="mousseur"
    targetLabel="robinet"
    targetLabelPlural="robinets"
    moduleEyebrow="Mousseurs"
    hasSubtypeGrouping={true}
    subtypeField="faucet_type"
    subtypeLabels={FAUCET_TYPE_LABELS}
    subtypeOrder={FAUCET_TYPE_ORDER}
    catalog={AERATOR_CATALOG}
    equipments={equipments}
    usages={usages}
    waterPricing={waterPricing}
    onResultChange={onResultChange}
  />
);

export default AeratorSubModule;
